// AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

export const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(
    () => localStorage.getItem('isLoggedIn') === 'true'
  );  // ローカルストレージからログイン状態を復元
  const [user, setUser] = useState(() => {
    // ローカルストレージからユーザー情報を復元
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const [subscriptions, setSubscriptions] = useState(() => {
    // ローカルストレージからサブスクリプション情報を復元
    const savedSubscriptions = localStorage.getItem('subscriptions');
    return savedSubscriptions ? JSON.parse(savedSubscriptions) : false;
  });

  useEffect(() => {
    // URLからトークンを取得してlocalStorageに保存する
    const urlParams = new URLSearchParams(window.location.search);
    const tokenFromURL = urlParams.get('token');
    if (tokenFromURL) {
      localStorage.setItem('authToken', tokenFromURL);
    }

    // localStorageからトークンを取得して検証する
    const token = localStorage.getItem('authToken');
    if (token && !isLoggedIn) {
      verifyToken(token);
    }
  }, [isLoggedIn]);

  const verifyToken = (token) => {
    // トークンを使用してユーザーの認証状態を確認するAPIリクエストを行う
    
    const apiBaseURL = process.env.REACT_APP_API_URL || 'https://hangul-match.com/';
    const apiUrl = `${apiBaseURL}api/verify-token`;
    axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
      .then(response => {
        // トークンが有効な場合、ログイン状態をtrueに設定
        setIsLoggedIn(true);
        setUser(response.data.user);
        setSubscriptions(response.data.subscriptions);
        // 状態をローカルストレージに保存
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('user', JSON.stringify(response.data.user));
        localStorage.setItem('subscriptions', JSON.stringify(response.data.subscriptions));
      })
      .catch(error => {
        // トークンが無効な場合、ログイン状態をfalseに設定し、トークンを削除
        setIsLoggedIn(false);
        localStorage.removeItem('authToken');
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('user');
        localStorage.removeItem('subscriptions');
      });
  };

  const logout = () => {
    // ログアウト処理
    setIsLoggedIn(false);
    setUser(null);
    setSubscriptions({});
    localStorage.removeItem('authToken');
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('user');
    localStorage.removeItem('subscriptions');
  };

  const value = {
    isLoggedIn,
    user,
    subscriptions,
    setIsLoggedIn,
    setUser,
    setSubscriptions,
    logout
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
